import styled from "styled-components";

export const FootNotes = styled.dl`
  color: var(--dusty-gray);
`;

export const FootNote = styled.div`
  display: flex;
  gap: var(--small-spacing);

  dd {
    margin: 0;
  }
`;
